import { ActivityFeed, Badge, Button, EmptyState, IconButton } from '@blend-ed/blendx-ui';
import classNames from 'classnames';
import React from 'react';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import notFound from '../../assets/notFound.svg';
import getTimeOrDate from '../../functions/getTimeOrDate';
import useNotificationsRead from '../../hooks/notifications/useNotificationsRead';
import { useFetchNotifications } from '../../hooks/useFetchNotifications';
import messages from './messages';

const Notifications = ({ intl }) => {

  const { data, loading, error, refetch } = useFetchNotifications();

  const { markAsRead } = useNotificationsRead();

  const markManyAsRead = (notifications) => {
    notifications.forEach(notification => {
      if (!notification.readStatus) {
        markAsRead({ variables: { keyId: notification.id, set: true } });
      }
    });
  };

  const renderNotificationList = (notifications) => (
    notifications.map((notification, index) => (
      <React.Fragment key={notification.id}>
        <ActivityFeed.Item
          index={index}
          className={classNames("notification-menu__item", {
            'notification-menu__item--unread': !notification.readStatus
          })}
          title={notification.notification.title}
          description={notification.notification.message}
          actions={
            <div className="notification-menu__item-time_status">
              <div className="notification-menu__item-time">
                {getTimeOrDate(notification.notification.createdAt)}
              </div>
              {!notification.readStatus && <div className="notification-menu__item-read-status" />}
            </div>
          }
          onClick={() => {
            if (!notification.readStatus) {
              markAsRead({
                variables: {
                  keyId: notification.id,
                  set: true
                }
              });
            }
          }}
        />
        {index !== notifications.length - 1 && <ActivityFeed.Divider />}
      </React.Fragment>
    ))
  );

  if (loading) return <div className='notifications'>
    <img src={notFound} alt={intl.formatMessage(messages.notFound)} />
  </div>

  const today = data?.todaysNotifications;
  const older = data?.olderNotifications;
  const todayUnreadCount = today?.filter(notification => !notification.readStatus).length;
  const olderUnreadCount = older?.filter(notification => !notification.readStatus).length;

  if (true) {
    return (
      <main className="notifications">
        <EmptyState
          type="notification"
          message={intl.formatMessage(messages.noNotifications)}
        />
      </main>
    );
  }

  return (
    <main className="notifications">
      {today?.length > 0 && (
        <div className="notifications__section">
          <div className="notifications__header">
            <div className="notifications__header-left">
              <div className="notifications__title">{intl.formatMessage(messages.today)}</div>
              {todayUnreadCount > 0 && <Badge size="sm" variant="primary">{todayUnreadCount}</Badge>}
            </div>
            <div className="notifications__header-right">
              <IconButton size="xs" variant="ghost-gray" icon="refresh" onClick={() => refetch()} />
              <Button
                variant="link-gray"
                className="notifications__mark-all-as-read"
                size="xs"
                onClick={() => markManyAsRead(today)}
              >
                {intl.formatMessage(messages.markAllAsRead)}
              </Button>
            </div>
          </div>
          <div className="notifications__content">
            <ActivityFeed className="notifications__activity-feed">
              <ActivityFeed.List className="notifications__activity-feed-list">
                {renderNotificationList(today)}
              </ActivityFeed.List>
            </ActivityFeed>
          </div>
        </div>
      )}

      {older?.length > 0 && (
        <div className="notifications__section">
          <div className="notifications__header">
            <div className="notifications__header-left">
              <div className="notifications__title">{intl.formatMessage(messages.older)}</div>
              {olderUnreadCount > 0 && <Badge size="sm" variant="primary">{olderUnreadCount}</Badge>}
            </div>
            <div className="notifications__header-right">
              <IconButton size="xs" variant="ghost-gray" icon="refresh" onClick={() => refetch()} />
              <Button
                variant="link-gray"
                className="notifications__mark-all-as-read"
                size="xs"
                onClick={() => markManyAsRead(older)}
              >
                {intl.formatMessage(messages.markAllAsRead)}
              </Button>
            </div>
          </div>
          <div className="notifications__content">
            <ActivityFeed className="notifications__activity-feed">
              <ActivityFeed.List className="notifications__activity-feed-list">
                {renderNotificationList(older)}
              </ActivityFeed.List>
            </ActivityFeed>
          </div>
        </div>
      )}
    </main>
  );
}

Notifications.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Notifications);